import React, { useState } from 'react';

import AutoAssignNotification from './AutoAssignNotification';
import TermsUpdateNotification from './TermsUpdateNotification';

interface GlobalNotificationProps {
  children: React.ReactNode;
}
const GlobalNotification = ({ children }: GlobalNotificationProps) => {
  const [idx, setIdx] = useState(0);

  const handleNext = (nextIdx: number) => {
    setIdx(nextIdx);
  };

  const notifications = [
    <TermsUpdateNotification key="terms-update" onNext={() => handleNext(1)} />,
    <AutoAssignNotification key="auto-assign" onNext={() => handleNext(2)} />,
  ];

  return (
    <>
      {children}
      {!!notifications.length && notifications[idx]}
    </>
  );
};

export default GlobalNotification;
